import IntegrationVerification from './IntegrationVerification';

export default IntegrationVerification;
